import styled from 'styled-components';

export const Logo = styled.h2`
    width: 100%;
    height: 80px;
    min-height: 80px;
    width: 191px;
    margin: 20px auto 30px;
    background: url('/app/logo2.png') no-repeat 50% 50%;
    background-size: contain;
    cursor: pointer;
`;

export const Title = styled.h2`
    font-size: 18px;
    color: rgba(255,255,255, 0.5);
    width: 100%;
    text-transform: uppercase;
    padding: 50px;
    font-weight: 100;
`;

export const Profile = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    flex: 1;
    height: 100%;
    background-color: #333;
    position: relative;
`;


export const ProfileCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;
    padding: 0 20px;
    margin-bottom: 20px;
`;


export const ProfileColor = styled.div.attrs(p => ({
    style: {
        color: p.foreground ?? '#fff',
        backgroundColor: p.color ?? '#999'
    }
}))`
    height: 70px;
    width: 70px;
    margin-right: 20px;
    border: 0;
    background-color: '#999';
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 40px;
`;

export const ProfileDetails = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
`;
export const ProfileName = styled.div`
    text-align: center;
    font-size: 18px;
    color: #fff;
    margin: 0 0 10px;
`;
export const ProfileEmail = styled.div`
    text-align: center;
    font-size: 14px;
    color: #999;
`;

export const Button = styled.button`
    border: 1px solid #555;
    background-color: transparent;
    margin: 0 auto 10px;
    border: 0;
    color: #555;
    height: 40px;
    width: 100%;
    text-transform: uppercase;
    transition: all .5s ease 0s;

    &.active {
        cursor: pointer;
        border: 1px solid ${props => props.color || props.theme.colors.main};
        color: ${props => props.color || props.theme.colors.main};
    }

    &.active:hover {
        background-color: ${props => props.color || props.theme.colors.main};
        color: #fff;
    }

    &.sharedSpace {
        width: auto;
        flex: 1;
    }

    &.tiny {
        width: 50px;
        font-size: 10px;
        padding: 0;
    }
`;

export const ButtonRow = styled.div`
    margin: 0 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: stretch;

    & ${Button}:not(:last-child) {
        margin-right: 10px;
    }
`;

export const Message = styled.div`
    color: #fff;
    font-size: 14px;
    margin: 30px 10px 20px;
`;

export const Label = styled.div`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
`;

export const Input = styled.input`
    border: 1px solid #555;
    background-color: #333;
    padding: 0 5px;
    color: #fff;
    height: 40px;
    margin: 5px 0 10px;

    &:focus{
        outline: none;
    }
`;

export const Error = styled.div`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    width: 100%;
    height: 30px;
    background-color: #500;
    border: 1px solid #900;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ButtonsWrapper = styled.div`
    padding: 10px 20px 15px;
`;

export const ScrollSpace = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    padding: 0 20px;
`;

export const ColorSelection = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 40px;
`;

export const ColorItem = styled.div.attrs((props) => ({
    style: {
        backgroundColor: props.color
    }
}))`
    height: 20px;
    width: 20px;
    margin-right: 5px;
    border-radius: 10px;
    border: 2px solid transparent;
    cursor: pointer;

    &:last-child {
        margin-right: 0;
    }

    &.selected {
        border: 2px solid #fff;
    }
`;

export const Version = styled.div`
    flex: 1;
    text-align: right;
    font-size: 10px;
    color: #999;
`;

export const LanguageSelector = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
`;

export const LanguageItems = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const LanguageItem = styled.div`
    height: 20px;
    width: 20px;
    margin-right: 5px;
    border-radius: 10px;
    background: url('/app/images/lang_${props => props.icon}.png') no-repeat 50% 50%;
    background-size: cover;
    overflow: hidden;
    box-sizing: border-box;
    border: 2px solid #999;
    cursor: pointer;

    &:last-child {
        margin-right: 0;
    }

    &.active {
        border: 2px solid #f92;
    }
`;